import React from "react";

class VisualizationComp extends React.Component {
  getImage() {
    //API CALL
  }

  render() {
    return <div>The image will be displayed in here</div>;
  }
}

export default VisualizationComp;
